import { MatchStatus } from "./../service/index";
export const getXY = (status: MatchStatus) => {
  return status.xy ? status.xy?.split(",").map(Number) : [undefined, undefined];
};
